import styled from "styled-components";

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;

export const HintText = styled.span<{ $status?: "idle" | "success" | "error" }>`
  font-size: 11px;
  color: ${({ $status }) => {
    if ($status === "success") return "#1d7a36";
    if ($status === "error") return "#b42318";
    return "#6a7583";
  }};
`;

export const IconButton = styled.button`
  width: 28px;
  height: 28px;
  border: 1px solid #b9c2cc;
  border-radius: 4px;
  background-color: #ffffff;
  color: #1f2b3a;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background-color: #f5f7fa;
  }
`;